import RunPage from "./RunPage";

export const RunPageConfig = {
  routes: [
    {
      path: "/run",
      exact: true,
      component: RunPage
    }
  ]
};
